/* Tone slot recipe: the variant × tone matrix without a combinatorial explosion. Each
   .rc-tone-<name> sets palette SLOTS from semantic --rc-color-* tokens; a component's variant
   (solid/soft/ghost/outline) reads the slots (button.css is the canonical consumer). Tints
   derive via color-mix, so re-skinning a --rc-color-* token re-skins every tone. No raw hex. */

.rc-tone-accent {
  --rc-tone-solid-bg: var(--rc-color-accent);
  --rc-tone-solid-bg-hover: var(--rc-color-accent-hover);
  --rc-tone-solid-fg: var(--rc-color-accent-fg);
  --rc-tone-fg: var(--rc-color-accent);
  --rc-tone-soft-bg: color-mix(in srgb, var(--rc-color-accent) 14%, transparent);
  --rc-tone-soft-bg-hover: color-mix(in srgb, var(--rc-color-accent) 22%, transparent);
  --rc-tone-ghost-bg-hover: color-mix(in srgb, var(--rc-color-accent) 12%, transparent);
  --rc-tone-border: color-mix(in srgb, var(--rc-color-accent) 40%, transparent);
}

.rc-tone-neutral {
  --rc-tone-solid-bg: var(--rc-color-text);
  --rc-tone-solid-bg-hover: color-mix(in srgb, var(--rc-color-text) 85%, var(--rc-color-bg));
  --rc-tone-solid-fg: var(--rc-color-bg);
  --rc-tone-fg: var(--rc-color-text);
  --rc-tone-soft-bg: color-mix(in srgb, var(--rc-color-text) 10%, transparent);
  --rc-tone-soft-bg-hover: color-mix(in srgb, var(--rc-color-text) 16%, transparent);
  --rc-tone-ghost-bg-hover: color-mix(in srgb, var(--rc-color-text) 8%, transparent);
  --rc-tone-border: var(--rc-color-border-strong);
}

.rc-tone-success {
  --rc-tone-solid-bg: var(--rc-color-success);
  --rc-tone-solid-bg-hover: color-mix(
    in srgb,
    var(--rc-color-success) 88%,
    var(--rc-color-neutral-950)
  );
  --rc-tone-solid-fg: var(--rc-color-success-fg);
  --rc-tone-fg: var(--rc-color-success);
  --rc-tone-soft-bg: color-mix(in srgb, var(--rc-color-success) 14%, transparent);
  --rc-tone-soft-bg-hover: color-mix(in srgb, var(--rc-color-success) 22%, transparent);
  --rc-tone-ghost-bg-hover: color-mix(in srgb, var(--rc-color-success) 12%, transparent);
  --rc-tone-border: color-mix(in srgb, var(--rc-color-success) 40%, transparent);
}

.rc-tone-warning {
  --rc-tone-solid-bg: var(--rc-color-warning);
  --rc-tone-solid-bg-hover: color-mix(
    in srgb,
    var(--rc-color-warning) 88%,
    var(--rc-color-neutral-950)
  );
  --rc-tone-solid-fg: var(--rc-color-warning-fg);
  --rc-tone-fg: var(--rc-color-warning);
  --rc-tone-soft-bg: color-mix(in srgb, var(--rc-color-warning) 16%, transparent);
  --rc-tone-soft-bg-hover: color-mix(in srgb, var(--rc-color-warning) 24%, transparent);
  --rc-tone-ghost-bg-hover: color-mix(in srgb, var(--rc-color-warning) 14%, transparent);
  --rc-tone-border: color-mix(in srgb, var(--rc-color-warning) 42%, transparent);
}

.rc-tone-danger {
  --rc-tone-solid-bg: var(--rc-color-danger);
  --rc-tone-solid-bg-hover: color-mix(
    in srgb,
    var(--rc-color-danger) 88%,
    var(--rc-color-neutral-950)
  );
  --rc-tone-solid-fg: var(--rc-color-danger-fg);
  --rc-tone-fg: var(--rc-color-danger);
  --rc-tone-soft-bg: color-mix(in srgb, var(--rc-color-danger) 14%, transparent);
  --rc-tone-soft-bg-hover: color-mix(in srgb, var(--rc-color-danger) 22%, transparent);
  --rc-tone-ghost-bg-hover: color-mix(in srgb, var(--rc-color-danger) 12%, transparent);
  --rc-tone-border: color-mix(in srgb, var(--rc-color-danger) 40%, transparent);
}

.rc-tone-info {
  --rc-tone-solid-bg: var(--rc-color-info);
  --rc-tone-solid-bg-hover: color-mix(
    in srgb,
    var(--rc-color-info) 88%,
    var(--rc-color-neutral-950)
  );
  --rc-tone-solid-fg: var(--rc-color-info-fg);
  --rc-tone-fg: var(--rc-color-info);
  --rc-tone-soft-bg: color-mix(in srgb, var(--rc-color-info) 14%, transparent);
  --rc-tone-soft-bg-hover: color-mix(in srgb, var(--rc-color-info) 22%, transparent);
  --rc-tone-ghost-bg-hover: color-mix(in srgb, var(--rc-color-info) 12%, transparent);
  --rc-tone-border: color-mix(in srgb, var(--rc-color-info) 40%, transparent);
}
